/* Vynsera enhancement layer - scroll reveal + sticky CTA + free-ship bar + premium blog UX.
   Fails safe: if JS or IO missing, nothing is hidden. */
(function () {
  var doc = document;
  var designMode = window.Shopify && Shopify.designMode;

  var FLAGSHIP = {
    handle: 'oregano-oil-black-seed-oil-capsules',
    variantId: '49032467742943',
    title: 'Oregano Oil + Black Seed Oil',
    img: 'https://cdn.shopify.com/s/files/1/0804/2915/4527/files/oregano-oil-black-seed-oil-15000mg-60-softgels.webp?v=1778131254'
  };
  var BLOG_PATH = '/blogs/vynsera-wellness-journal';
  function patchContext() { return !!doc.querySelector('.vpe, .vp-catalog, .vph, .vyn-patch-article, .vyn-journal-guide'); }

  var PRODUCTS = [
    { handle: 'oregano-oil-black-seed-oil-capsules', size: '60 Softgels', img: 'https://cdn.shopify.com/s/files/1/0804/2915/4527/files/oregano-oil-black-seed-oil-15000mg-60-softgels.webp?v=1778131254' },
    { handle: 'oregano-oil-capsules-180', size: '180 Softgels', img: 'https://cdn.shopify.com/s/files/1/0804/2915/4527/files/oregano_oil_180_gets.webp?v=1778796828' },
    { handle: 'oregano-oil-capsules', size: '300 Softgels', img: 'https://cdn.shopify.com/s/files/1/0804/2915/4527/files/oil-of-oregano-black-seed-oil-6000mg-300-softgels.webp?v=1778131311' }
  ];

  var REFERENCES = [
    { t: 'Carvacrol - a natural phenolic with antimicrobial, anti-inflammatory and antioxidant properties (Antibiotics, 2023)', u: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC10215463/' },
    { t: 'Essential oils of oregano: composition and biological activity (review)', u: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC6152729/' },
    { t: 'Oregano supplementation and oxidative-stress markers in adults (randomized trial)', u: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9823977/' },
    { t: 'Black seed (Nigella sativa) and thymoquinone: review of human clinical trials (2017)', u: 'https://pubmed.ncbi.nlm.nih.gov/30087794/' },
    { t: 'Thymoquinone content in commercial black seed oil products (quality analysis)', u: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC9460610/' },
    { t: 'Oregano oil: benefits, uses and cautions - consumer-health overview (WebMD)', u: 'https://www.webmd.com/diet/oregano-oil-good-for-you' }
  ];

  /* ---------------- Scroll reveal (unchanged behaviour) ---------------- */
  function initReveal() {
    if (designMode || (window.matchMedia && window.matchMedia('(max-width: 989px)').matches)) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    doc.body.classList.add('vyn-motion');
    var sections = Array.prototype.slice.call(doc.querySelectorAll('main .shopify-section'));
    sections.forEach(function (sec, i) {
      if (i === 0) return;
      sec.classList.add('vyn-reveal');
    });
    var targets = doc.querySelectorAll('.vyn-reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('vyn-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vyn-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.01, rootMargin: '0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Helpers ---------------- */
  function path() { return (window.location.pathname || '').toLowerCase(); }
  function onCartOrCheckout() {
    var p = path();
    return p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0 || p.indexOf('/cart/') !== -1;
  }
  function el(tag, cls, html) {
    var e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------------- Free shipping top bar ---------------- */
  function initShipBar() {
    if (designMode) return;
    if (doc.querySelector('.vyn-ship-bar')) return;
    var bar = el('div', 'vyn-ship-bar',
      '<span class="vyn-ship-dot"></span> Free tracked shipping worldwide' + (patchContext() ? '' : ' &nbsp;&middot;&nbsp; The Oregano Oil Bible included free with every order'));
    doc.body.insertBefore(bar, doc.body.firstChild);
  }

  /* ---------------- Toast (PDP add-to-cart only) ---------------- */
  function toast(msg, href) {
    var t = doc.querySelector('.vyn-toast');
    if (!t) { t = el('div', 'vyn-toast'); doc.body.appendChild(t); }
    t.innerHTML = msg + (href ? ' <a href="' + href + '">View cart &rarr;</a>' : '');
    t.classList.add('vyn-toast--on');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('vyn-toast--on'); }, 4200);
  }

  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var bubbles = doc.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
        bubbles.forEach(function (b) { b.textContent = c.item_count; });
        var icon = doc.getElementById('cart-icon-bubble');
        if (icon && !icon.querySelector('.cart-count-bubble') && c.item_count > 0) {
          var bub = el('div', 'cart-count-bubble', '<span aria-hidden="true">' + c.item_count + '</span>');
          icon.appendChild(bub);
        }
      })['catch'](function () {});
  }

  function currentProductContext() {
    var form = doc.querySelector('form[action*="/cart/add"]');
    var ctx = null;
    if ((path().indexOf('/products/') !== -1 || doc.querySelector('main [id^="MainProduct-"]')) && form) {
      var idEl = form.querySelector('[name="id"]');
      var priceEl = doc.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--regular, .price__container .price-item');
      ctx = {
        variantId: idEl ? idEl.value : FLAGSHIP.variantId,
        price: priceEl ? priceEl.textContent.trim() : ''
      };
    }
    return ctx;
  }

  /* Reads the product being viewed, so the sticky bar always matches the page. */
  function currentProductInfo() {
    var title = '';
    var h1 = doc.querySelector('.product__title h1') || doc.querySelector('.product__title, h1');
    if (h1 && h1.textContent) title = h1.textContent.trim();
    if (!title) {
      var ogt = doc.querySelector('meta[property="og:title"]');
      if (ogt && ogt.content) title = ogt.content.split(' | ')[0].trim();
    }
    var img = '';
    var ogi = doc.querySelector('meta[property="og:image"]');
    if (ogi && ogi.content) img = ogi.content;
    if (!img) {
      var mi = doc.querySelector('.product__media img, .product-media-container img');
      if (mi) img = mi.currentSrc || mi.src || '';
    }
    return { title: title || FLAGSHIP.title, img: img || FLAGSHIP.img };
  }

  function buySection() {
    return doc.querySelector('product-form, .product-form, form[action*="/cart/add"]') || doc.querySelector('.product__info-container');
  }

  function addToCart(variantId, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('vyn-loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      updateCartCount();
      toast('Added to cart &nbsp;&check;', '/cart');
    })['catch'](function () {
      window.location.reload();
    })['finally'](function () {
      if (btn) { btn.disabled = false; btn.classList.remove('vyn-loading'); }
    });
  }

  /* ---------------- Sticky CTA bar ----------------
     Bridge pages (blog/home/collection): "Shop Now" -> flagship product page.
     Product page: shows THIS product's name, image and price; the button
     scrolls back up to the buy section so bundles/options can be chosen. */
  function initStickyAtc() {
    if (designMode) return;
    if (doc.querySelector(".vph")) return;
    if (onCartOrCheckout()) return;
    if (doc.querySelector('.vyn-sticky')) return;

    var onProduct = path().indexOf('/products/') !== -1 || !!doc.querySelector('main [id^="MainProduct-"]');
    var onPatch = onProduct && !!doc.querySelector('.vm-intro');
    var ctx = currentProductContext();
    var info = onProduct ? currentProductInfo() : (patchContext() ? { title: 'Explore your patch routine', img: '' } : { title: FLAGSHIP.title, img: FLAGSHIP.img });

    var subHtml, actionHtml;
    if (onProduct) {
      subHtml = !onPatch && ctx && ctx.price ? '<span class="vyn-sticky-price">' + esc(ctx.price) + '</span>' : '<span class="vyn-sticky-ship">Free worldwide shipping</span>';
      actionHtml = '<button type="button" class="vyn-sticky-btn">' + (onPatch ? 'Choose options' : 'Add to Cart') + '</button>';
    } else {
      subHtml = '<span class="vyn-sticky-ship">Free worldwide shipping</span>';
      actionHtml = patchContext() ? '<a class="vyn-sticky-btn" href="/pages/how-patches-work">Patch guide</a>' : '<a class="vyn-sticky-btn" href="/products/' + FLAGSHIP.handle + '">Shop Now</a>';
    }

    var bar = el('div', 'vyn-sticky');
    bar.innerHTML =
      '<div class="vyn-sticky-in">' +
        (info.img ? '<img class="vyn-sticky-img" src="' + esc(info.img) + '" alt="" width="46" height="46" loading="lazy">' : '') +
        '<div class="vyn-sticky-txt"><span class="vyn-sticky-name">' + esc(info.title) + '</span>' + subHtml + '</div>' +
        actionHtml +
      '</div>';
    doc.body.appendChild(bar);
    doc.body.classList.add('vyn-has-sticky');

    var buyVisible = false;
    if (onProduct) {
      var btn = bar.querySelector('.vyn-sticky-btn');
      btn.addEventListener('click', function () {
        var target = buySection();
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - 120;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        } else {
          var live = currentProductContext();
          if (onPatch) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
          else { addToCart(live ? live.variantId : FLAGSHIP.variantId, btn); }
        }
      });
      var tgt = buySection();
      if (tgt && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          buyVisible = entries[0].isIntersecting;
          onScroll();
        }).observe(tgt);
      }
    }

    function onScroll() {
      if (window.scrollY > 280 && !buyVisible) bar.classList.add('vyn-sticky--on');
      else bar.classList.remove('vyn-sticky--on');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Article enhancements ---------------- */
  function readingMinutes(scope) {
    var txt = (scope.textContent || '').trim();
    var words = txt ? txt.split(/\s+/).length : 0;
    return Math.max(1, Math.round(words / 200));
  }

  function buildRefs() {
    var items = REFERENCES.map(function (r) {
      var host = r.u.split('/')[2].replace(/^www\./, '');
      return '<li><a href="' + r.u + '" target="_blank" rel="noopener">' + r.t + ' <span class="vyn-refs-src">' + host + ' &nearr;</span></a></li>';
    }).join('');
    return '<div class="vyn-refs"><h2 class="vyn-refs-h">References &amp; further reading</h2>' +
      '<p class="vyn-refs-note">Independent peer-reviewed and public-health sources on oregano oil (carvacrol) and black seed oil (thymoquinone). These open in a new tab; Vynsera does not control external pages.</p>' +
      '<ol class="vyn-refs-list">' + items + '</ol></div>';
  }

  function buildShopBlock() {
    if (patchContext()) return '<div class="vyn-shop"><h2 class="vyn-shop-h">Find your patch routine</h2><p>Compare the formula, directions and purchase options for the exact product.</p><p><a href="/collections/patches">Explore all patches &rarr;</a> &nbsp; <a href="/pages/how-patches-work">Read the complete patch guide &rarr;</a></p></div>';
    var cards = PRODUCTS.map(function (p) {
      return '<a class="vyn-shop-card" href="/products/' + p.handle + '">' +
        '<span class="vyn-shop-img" style="background-image:url(' + p.img + ')"></span>' +
        '<span class="vyn-shop-body">' +
          '<span class="vyn-shop-size">' + p.size + '</span>' +
          '<span class="vyn-shop-sub">Oregano Oil + Black Seed Oil</span>' +
          '<span class="vyn-shop-cta">View product &rarr;</span>' +
        '</span></a>';
    }).join('');
    return '<div class="vyn-shop"><h2 class="vyn-shop-h">Shop Vynsera</h2>' +
      '<p class="vyn-shop-note">Free tracked worldwide shipping &middot; The Oregano Oil Bible included free with every order</p>' +
      '<div class="vyn-shop-grid">' + cards + '</div></div>';
  }

  function buildShareRow() {
    var u = encodeURIComponent(window.location.href);
    var t = encodeURIComponent(doc.title || 'Vynsera Wellness Journal');
    return '<div class="vyn-share">' +
      '<span class="vyn-share-label">Sharing is caring</span>' +
      '<div class="vyn-share-row">' +
        '<a class="vyn-share-btn vyn-fb" target="_blank" rel="noopener" aria-label="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=' + u + '">Facebook</a>' +
        '<a class="vyn-share-btn vyn-x" target="_blank" rel="noopener" aria-label="Share on X" href="https://twitter.com/intent/tweet?url=' + u + '&text=' + t + '">X</a>' +
        '<a class="vyn-share-btn vyn-pin" target="_blank" rel="noopener" aria-label="Share on Pinterest" href="https://pinterest.com/pin/create/button/?url=' + u + '&description=' + t + '">Pinterest</a>' +
        '<a class="vyn-share-btn vyn-wa" target="_blank" rel="noopener" aria-label="Share on WhatsApp" href="https://api.whatsapp.com/send?text=' + t + '%20' + u + '">WhatsApp</a>' +
        '<a class="vyn-share-btn vyn-em" aria-label="Share by email" href="mailto:?subject=' + t + '&body=' + u + '">Email</a>' +
        '<button type="button" class="vyn-share-btn vyn-copy" aria-label="Copy link">Copy link</button>' +
      '</div></div>';
  }

  function injectBreadcrumbSchema(title) {
    var data = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', position: 1, name: 'Home', item: window.location.origin + '/' },
        { '@type': 'ListItem', position: 2, name: 'Wellness Journal', item: window.location.origin + BLOG_PATH },
        { '@type': 'ListItem', position: 3, name: title }
      ]
    };
    var s = doc.createElement('script');
    s.type = 'application/ld+json';
    s.textContent = JSON.stringify(data);
    doc.head.appendChild(s);
  }

  function initArticle() {
    var tpl = doc.querySelector('.article-template');
    if (!tpl) return;
    if (tpl.getAttribute('data-vyn') === '1') return;
    tpl.setAttribute('data-vyn', '1');

    var header = tpl.querySelector('header.page-width');
    var titleEl = tpl.querySelector('.article-template__title');
    var content = tpl.querySelector('.article-template__content');
    var titleText = titleEl ? titleEl.textContent.trim() : (doc.title || '');

    if (header && !tpl.querySelector('.vyn-crumbs')) {
      var crumbs = el('nav', 'vyn-crumbs',
        '<a href="/">Home</a><span>&rsaquo;</span><a href="' + BLOG_PATH + '">Wellness Journal</a><span>&rsaquo;</span><span class="vyn-crumb-cur">' + titleText + '</span>');
      header.insertBefore(crumbs, header.firstChild);
    }

    if (header && content && !tpl.querySelector('.vyn-meta')) {
      var mins = readingMinutes(content);
      var meta = el('div', 'vyn-meta',
        '<span class="vyn-meta-by">By <strong>The Vynsera Wellness Team</strong></span>' +
        '<span class="vyn-meta-sep">&middot;</span>' +
        '<span>' + mins + ' min read</span>');
      header.appendChild(meta);
    }

    if (content && !content.querySelector('.vyn-disclaimer')) {
      var disc = el('div', 'vyn-disclaimer',
        '<strong>Educational content, not medical advice.</strong> These statements have not been evaluated by the FDA. Vynsera products are not intended to diagnose, treat, cure, or prevent any disease. Speak with your doctor before starting a new supplement.');
      content.insertBefore(disc, content.firstChild);
    }

    var journalShare = tpl.querySelector('.vynsera-journal-share');
    var shareWrap = tpl.querySelector('.article-template__social-sharing');
    if (!journalShare && shareWrap && !shareWrap.querySelector('.vyn-share')) {
      var native = shareWrap.querySelector('share-button');
      if (native) native.style.display = 'none';
      shareWrap.insertAdjacentHTML('beforeend', buildShareRow());
    } else if (!journalShare && !shareWrap && content && !tpl.querySelector('.vyn-share')) {
      var sw = el('div', 'article-template__social-sharing page-width page-width--narrow', buildShareRow());
      content.parentNode.insertBefore(sw, content.nextSibling);
    }

    var copyBtn = tpl.querySelector('.vyn-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var done = function () { copyBtn.textContent = 'Copied!'; setTimeout(function () { copyBtn.textContent = 'Copy link'; }, 2000); };
        if (navigator.clipboard) { navigator.clipboard.writeText(window.location.href).then(done, done); }
        else { done(); }
      });
    }

    var back = tpl.querySelector('.article-template__back');
    if (back) {
      if (!tpl.querySelector('.vyn-shop')) {
        var shopWrap = el('div', 'page-width page-width--narrow', buildShopBlock());
        back.parentNode.insertBefore(shopWrap, back);
      }
    }

    injectBreadcrumbSchema(titleText);
  }

  /* ---------------- Boot ---------------- */
  function init() {
    try { initReveal(); } catch (e) {}
    try { initShipBar(); } catch (e) {}
    try { initStickyAtc(); } catch (e) {}
    try { initArticle(); } catch (e) {}
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', init); } else { init(); }
})();